import { createFileRoute } from "@tanstack/react-router";
import { AuthPage } from "@/components/auth-page";

export const Route = createFileRoute("/sign-out")({
	component: SignOutPage,
	ssr: false,
});

function SignOutPage() {
	return <AuthPage view="SIGN_OUT" />;
}
